import React from 'react';
import { useClientExportFlow } from '../../hooks/useClientExportFlow';
import BandwidthExportMenu from './BandwidthExportMenu';
import type { BandwidthExcelExport } from './bandwidthDashboardExcelExport';
import type { BandwidthPdfExport } from './bandwidthDashboardPdfExport';

export interface BandwidthPanelExportShellProps {
  disabled: boolean;
  ariaLabel: string;
  buildExcel: () => BandwidthExcelExport | null;
  buildPdf: () => BandwidthPdfExport | null;
}

/**
 * Wraps Bandwidth PDF/Excel exports with the same progress modal pattern as Cases list
 * (`GenericExportButton`): open dialog → prepare file → Download → close.
 */
const BandwidthPanelExportShell: React.FC<BandwidthPanelExportShellProps> = ({
  disabled,
  ariaLabel,
  buildExcel,
  buildPdf,
}) => {
  const { run, modal } = useClientExportFlow();

  return (
    <>
      {modal}
      <BandwidthExportMenu
        disabled={disabled}
        ariaLabel={ariaLabel}
        onExportPdf={() =>
          void run({
            downloadButtonLabel: 'Download PDF',
            work: async () => {
              const r = buildPdf();
              if (!r) throw new Error('No data to export.');
              return {
                files: r,
                summaryLines: ['Your PDF is ready to download.'],
              };
            },
          })
        }
        onExportExcel={() =>
          void run({
            downloadButtonLabel: 'Download Excel',
            work: async () => {
              const r = buildExcel();
              if (!r) throw new Error('No data to export.');
              return {
                files: r,
                summaryLines: ['Your Excel file is ready to download.'],
              };
            },
          })
        }
      />
    </>
  );
};

export default BandwidthPanelExportShell;
